var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.5H2.5M13.3332 10.5C13.3332 6.3332 11.8416 3 10 3C8.1584 3 6.6668 6.3332 6.6668 10.5C6.6668 14.6668 8.1584 18 10 18C11.8416 18 13.3332 14.6668 13.3332 10.5Z",
    stroke: "#58486C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18C14.142 18 17.5 14.642 17.5 10.5C17.5 6.358 14.142 3 10 3C5.858 3 2.5 6.358 2.5 10.5C2.5 14.642 5.858 18 10 18Z",
    stroke: "#58486C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowse);
export default __webpack_public_path__ + "static/media/browse.9ec71a82924e11ce9b889883b6183afb.svg";
export { ForwardRef as ReactComponent };